import { createSlice } from '@reduxjs/toolkit'
import {
  createTimetable,
  deleteTimetable,
  editTimetable,
  getTimetable,
  getTimetableCourse,
} from '../../builders/timetable/timetable.builder'

const initialState = {
  loading: false,
  timetableData: [],
  timetableCourseData: {},
}

const timetableSlice = createSlice({
  name: 'timetable',
  initialState,
  reducers: {

    clearExtraReducers  : (state) =>{
      state.loading = false,
      state.timetableData = [],
      state.timetableCourseData = {}
     },
  },


  extraReducers: (builder) => {
    builder.addCase(getTimetable.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getTimetable.fulfilled, (state, action) => {
      state.timetableData = action.payload
      state.loading = false
    })
    builder.addCase(getTimetable.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getTimetableCourse.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getTimetableCourse.fulfilled, (state, action) => {
      state.timetableCourseData = action.payload
      state.loading = false
    })
    builder.addCase(getTimetableCourse.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(editTimetable.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editTimetable.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editTimetable.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(deleteTimetable.pending, (state) => {
      state.loading = true
    })
    builder.addCase(deleteTimetable.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(deleteTimetable.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createTimetable.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createTimetable.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createTimetable.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { timetableData } = timetableSlice.actions

export default timetableSlice.reducer
